<template>
  <b-form-input
    class="mt-2 searchtext"
    style="background: white"
    :placeholder="title"
    @input="updateValue"
    v-model="val"
    v-on:keyup.enter="search"
    v-bind="$attrs"
  ></b-form-input>
</template>

<script>
export default {
  name: "SearchInput",
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    value: [String, Number],
  },
  methods: {
    updateValue() {
      this.$emit("input", this.val);
    },
    search() {
      this.$emit("search", this.val);
    },
  },
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.val = newValue;
    },
  },
};
</script>

<style scoped>
.searchtext {
  background: white;
}
</style>
